import routes from "../routes/routesCode";

class Auth {
  constructor() {
    this.authenticated = Boolean(localStorage.token);
  }

  login(token, navigate, socketState) {
    localStorage.setItem("token", token.accessToken);
    localStorage.setItem("refreshToken", token.refreshToken);
    this.authenticated = Boolean(localStorage.token);
    socketState.connectWS();
    navigate(routes.projects.path);
  }

  logout(navigate, socketState) {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    this.authenticated = Boolean(localStorage.token);
    socketState.disconnectWS();
    navigate(routes.logIn.path);
  }

  isAuthenticated() {
    return this.authenticated;
  }
}

export default new Auth();
